import { getCO2Aequivalent } from '../getCO2Aequivalent';
import { getUmrechungsFaktor } from '../getUmrechnungsFaktor';

export function getDataForKraftstoff(row: any, jahr: number, data: any, key?: string) {
    const energietraeger = key ? row[key] : row.energietraeger_tid;
    let faktor_um: any = {};
    let faktor_mengenumrechnung = 1;
    let key_use = '';
    let einheit = '';
    if (energietraeger === 'Benzin [Liter]') {
        einheit = 'Liter';
        key_use = 'benzin';
        faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'ottokraftstoffe', (data: any) => faktor_um = data);
    } else if (energietraeger === 'Diesel [Liter]') {
        einheit = 'Liter';
        key_use = 'diesel';
        faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'dieselkraftstoffe', (data: any) => faktor_um = data);
    } else if (energietraeger === 'LPG [Liter]') {
        einheit = 'Liter';
        key_use = 'lpg';
        faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'fluessiggas_l', (data: any) => faktor_um = data);
    } else if (energietraeger === 'Wasserstoff [kg]') {
        einheit = 'kg';
        key_use = 'wasserstoff';
        faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'wasserstoff', (data: any) => faktor_um = data);
    } else if (energietraeger === 'Wasserstoff [kWh]') {
        einheit = 'kWh';
        key_use = 'wasserstoff';
    } else if (energietraeger === 'Erdgas - CNG [kg]') {
        einheit = 'kg';
        key_use = 'erdgas';
        faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'erdgas_cng_kg', (data: any) => faktor_um = data);
    } else if (energietraeger === 'Erdgas - LNG [kg]') {
        einheit = 'kg';
        key_use = 'erdgas';
        faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'erdgas_lng_kg', (data: any) => faktor_um = data);
    } else if (energietraeger === 'Erdgas [kWh]') {
        einheit = 'kWh';
        key_use = 'erdgas';
    } else if (energietraeger === 'Ladestrom [kWh]') {
        einheit = 'kWh';
        key_use = 'strom';
    } else if (energietraeger === 'Biodiesel [Liter]') {
        einheit = 'Liter';
        key_use = 'biodiesel';
        faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'biodiesel', (data: any) => faktor_um = data);
    } else if (energietraeger === 'Bioethanol [Liter]') {
        einheit = 'Liter';
        key_use = 'bioethanol';
        faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'bioethanol', (data: any) => faktor_um = data);
    }

    const name = ((energietraeger || '').toString().split('['))[0].trim();
    const aq = getCO2Aequivalent(data, jahr, key_use, false);
    const co2 = aq.wert * row.verbrauch * faktor_mengenumrechnung;
    const co2_s3 = aq.wert3 * row.verbrauch * faktor_mengenumrechnung;
    const quelle_um = faktor_um[`quelle_${key_use}`] || faktor_um[`quelle_${key_use}_${einheit.toLowerCase()}`];
    // console.log(jahr, energietraeger, faktor_mengenumrechnung, faktor_um);

    return {
        energietraeger,
        name,
        faktor: aq.wert * faktor_mengenumrechnung,
        quelle: aq.quelle,
        faktor_s3: aq.wert3 * faktor_mengenumrechnung,
        einheit,
        co2,
        co2_s3,
        faktor_co2: aq.wert,
        quelle_co2: aq.quelle,
        faktor_um: faktor_mengenumrechnung,
        quelle_um: quelle_um,
        datenqualitaet_1: aq.datenqualitaet_1,
        datenqualitaet_2: aq.datenqualitaet_2,
        datenqualitaet_3: aq.datenqualitaet_3
    };
}
